import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignOut, faICursor,faGear, faX } from '@fortawesome/free-solid-svg-icons';

import clsx from 'clsx';
import { useScale } from './Scale';

import GameComponent from './game/GameComponent';
import Modal from './modals/Modal';
import SettingsModal from './modals/SettingsModal';
import LoadingScreen from './LoadingScreen';
import ChangelogModal from './modals/ChangelogModal';
import LoginModal from './modals/LoginModal';
import SignupModal from './modals/SignupModal';
import ConnectionError from './modals/ConnectionError';

import { clearAccount, setAccount, logoutAsync, changeNameAsync, changeClanAsync, changeBioAsync } from '../redux/account/slice';
import { selectAccount } from '../redux/account/selector';
import api from '../api';

import SettingsImg from '../assets/img/settings.png';
import DiscordLogo from '../assets/img/discordLogo.png';
import GithubLogo from '../assets/img/githubLogo.png';
import SignupImg from '../assets/img/signup.png';
import LoginImg from '../assets/img/login.png';
import './App.scss';
import GemCount from './ValueCnt';
import ShopButton from './ShopButton';
import InventoryButton from './InventoryButton';
import LeaderboardButton from './LeaderboardButton';
import ShopModal from './modals/ShopModal';
import InventoryModal from './modals/InventoryModal';
import MigrationModal from './modals/MigrationModal';
import { getCookies, playVideoAd } from '../helpers';
import Ad from './Ad';
import { Settings } from '../game/Settings';
import { getServerList, updatePing } from '../ServerList';
import AccountCard from './AccountCard';
import ChangelogCard from './ChangelogCard';
// import Game from '../game/scenes/Game';
import titleImg from '../assets/img/final.png';
import Leaderboard from './game/Leaderboard';
import { crazygamesSDK } from '../crazygames/sdk';
import { initializeDataStorage } from '../crazygames/dataStorage';

import * as cosmetics from '../game/cosmetics.json'

let debugMode = false;
try {
  debugMode = window.location.search.includes("debugAlertMode");
  } catch(e) {}

function App() {
  let { skins } = cosmetics;
  const RESET_HOUR = 23; // 0-23 utc

  const dispatch = useDispatch();
  const account = useSelector(selectAccount);

  const scale = useScale(false);
  const [name, setName] = useState('');
  const [gameStarted, setGameStarted] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [modal, setModal] = useState<any>(null);
  const [connectionError, setConnectionError] = useState<string>('');
  const [firstGame, setFirstGame] = useState(true);
  const [isConnected, setIsConnected] = useState(false);
  const [accountReady, setAccountReady] = useState(false);
  const [assetsLoaded, setAssetsLoaded] = useState(false);
  const [game, setGame] = useState<Phaser.Game | undefined>(window.phaser_game);
  const [crazygamesAuthReady, setCrazygamesAuthReady] = useState(false);

  const [dimensions, setDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });

  // Detect if we're in a small desktop iframe (like CrazyGames)
  const isSmallDesktopIframe = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const isLandscape = width > height;
    const isSmall = width < 1040;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    return isSmall && isLandscape && !isMobile;
  };

  const [isSmallIframe, setIsSmallIframe] = useState(isSmallDesktopIframe());

  const messages = [
    "Tip: The Lumberjack's ability has multiple uses: finding chests, defending against enemies, and breaking chests faster!",
    "Tip: The Super Archer's ability cancels its current swordthrow and resets its throw cooldown, allowing you to throw twice!",
    "Tip: The Rook's ability dashes itself in the last direction it moved in, helping out for both mobility and offense!",
    "Tip: The Defender doesn't deal much damage, but has a ton of health and size, making it great for preventing attacks!",
    "Tip: The Defender's ability can be used to knock enemies across the map, pushing them far away!",
    "Tip: The Tank's ability greatly increases its size and regen, providing lots of defense for a short time!",
    "Tip: The Samurai has lots of knockback reduction, making it harder for other players to push you around!",
    "Tip: The Rook can only move in four directions, but has great stats that make up for it!",
    "Tip: The Berserker has low health but high damage, making it great for aggressive playstyles!",
    "Tip: The Berserker's ability only somewhat increases its stats, but lasts a long time, helping for a final push on an enemy!",
    "Tip: The Vampire's ability greatly increases its lifesteal, damage, & speed, making it great for healing and killing enemies!",
    "Tip: The Vampire is very good at fighting teams of players, as it can heal off of each of them!",
    "Tip: The Warrior is great for being aggressive while keeping good defensive stats, making it great for fighting!",
    "Tip: The Warrior's ability increases its speed, damage and size, making it great for chasing down enemies!",
    "Tip: The Lumberjack deals bonus damage to chests at the cost of less damage to mobs and players, making it good for farming!",
    "Tip: The Fighter has faster attack speed, regen time, and ability cooldown, letting it be apart of more fights!",
    "Tip: The Fighter ability affects stats very slightly, but can be activated very often.",
    "Tip: The Stalker's ability makes it invisible and very fast, which is helpful for both ambushes and escapes!",
    "Tip: The Archer makes swordthrows better and, while mediocre by itself, evolves to the Sniper and Super Archer at 50k coins!",
    "Tip: The Sniper can maintain distance from enemies due to its fast throwing and increased sight range!",
    "Tip: Throwing your sword temporarily prevents melee attacks, making you vulnerable to enemies up close",
    "Tip: Predicting enemy swordthrows can help you dodge them more often!",
    "Tip: Join the Swordbattle Discord Server for more detailed changelogs and patch notes!",
    "Tip: Join the Swordbattle Discord Server to chat with other players and get help!",
    "Tip: Join the Swordbattle Discord Server to vote on polls to decide the future of Swordbattle.io!",
    "Tip: You can report bugs and suggest features on the Swordbattle.io Discord Server!",
    "Tip: You can report players through the Swordbattle.io Discord Server.",
    "Tip: Join the Swordbattle Discord Server for sneak peaks and exclusive news!",
    "Tip: Boosting the Swordbattle Discord Server gives you a permanent Supporter tag on your profile, and an exclusive name color!",
    "Tip: Boosting the Swordbattle Discord Server gives you a permanent Supporter tag on your profile, and an exclusive name color!",
    "Tip: Boosting the Swordbattle Discord Server gives you access to exclusive channels and in-game giveaways!",
    "Tip: You can only regen after not taking damage for a couple seconds, so stay away from mobs and lava to keep regening!",
    "Tip: The Ancient Statues have two attacks: throwing damaging stone swords and a boulder that knocks you far back!",
    "Tip: The Roku fires a lot of fireballs when you get too close, so stay back to avoid taking damage!",
    "Tip: Press C, E, Shift, or Right Click on computer to throw your sword",
    "Tip: You can hide the Leaderboard, Minimap and Evolutions panels by clicking on their nametags!",
    "Tip: TPS measures how well the server is running, with 20 being the best. Report low TPS to support@swordbattle.io or on Discord.",
    "Tip: Report server crashes, restarts, or disconnects to support@swordbattle.io or the Swordbattle Discord Server.",
    "Tip: Forgot your password or username? You can reset it by emailing support@swordbattle.io",
    "Tip: Get enough Coins or XP to get onto the Leaderboards!",
    "Tip: Creating an account lets you save your progress and earn cool skins through the shop!",
    "Tip: Create an account to get a blue nametag and access to the shop and inventory!",
    "Tip: Creating an account will let you earn XP and make yourself more recognizable to other players!",
    "Tip: Create an account to be able to get on the Leaderboards and see your rank!",
    "Tip: The 4 tiers of evolutions are unlocked at 1000, 5000, 20000, and 50000 Coins!",
    "Tip: You earn more and more mastery when getting more coins in a single life!",
    "Tip: To maximize the mastery you earn, try to get as many coins as possible without dying!",
    "Tip: Getting a bunch of games with 500000+ coins will help you earn mastery much faster!",
    
  ];
  const [randomMessage] = useState(() => messages[Math.floor(Math.random() * messages.length)]);

  const bottomLeftContainerStyle: React.CSSProperties = {
    position: 'fixed',
    left: 0,
    bottom: 0,
    transform: `scale(${scale.factor})`,
    transformOrigin: 'bottom left',
    pointerEvents: 'none',
  };

  useEffect(() => {

    // debounce resize
    let timeout: any;
    const onResize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setDimensions({ width: window.innerWidth, height: window.innerHeight });
        setIsSmallIframe(isSmallDesktopIframe());
      }, 100);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if(gameStarted && firstGame) setFirstGame(false);
    if(gameStarted) return;
    setTimeout(() => {
      // Only handle initial login for non-CrazyGames environments
      // CrazyGames auth is handled separately in the other useEffect

      const isPotentiallyCrazygames = typeof window !== 'undefined' &&
                                      window.location.hostname.includes('crazygames');

      const shouldUse = crazygamesSDK.shouldUseSDK();
      const isUserAvailable = crazygamesSDK.isUserAccountAvailable();
      const isCrazygames = shouldUse && isUserAvailable;

      console.log('[Auth Initial] isPotentiallyCrazygames:', isPotentiallyCrazygames);
      console.log('[Auth Initial] shouldUseSDK:', shouldUse, 'isUserAccountAvailable:', isUserAvailable, 'isCrazygames:', isCrazygames);
      console.log('[Auth Initial] SDK initialized:', crazygamesSDK.isInitialized());

      if (isPotentiallyCrazygames || isCrazygames) {
        console.log('[Auth] Skipping initial login for CrazyGames environment (will be handled by CrazyGames login flow)');
        setAccountReady(true);
        return;
      }

      console.log('[Auth Initial] Not CrazyGames environment, checking localStorage secret...');

      let secret: string | null = null;
      try {
       secret = window.localStorage.getItem('secret');
      } catch(e) {
        console.log('Error getting secret', e);
      }
      console.log('[Auth Initial] localStorage secret:', secret ? 'exists (length: ' + secret.length + ')' : 'null/empty');

    if(!secret || secret === 'undefined' || secret === 'null') {
      console.log('[Auth Initial] No valid secret found, setting guest account');
      if(secret === 'undefined' || secret === 'null') {
        try {
          window.localStorage.removeItem('secret');
        } catch(e) {
          console.log('Error removing bad secret', e);
        }
      }
      dispatch(clearAccount());
      setAccountReady(true);
    } else {
      console.log('[Auth Initial] Valid secret found, attempting loginWithSecret...');
      api.post(`${api.endpoint}/auth/loginWithSecret`, null, (data) => {
        console.log('[Auth Initial] loginWithSecret response:', data);
        setAccountReady(true);
        if (data.account) {
          data.account.secret = data.secret;
          dispatch(setAccount(data.account));
        } else {
          dispatch(clearAccount());
        }
      });
    }
  }, 10);

  if(!firstGame) return;
    // setModal(<ChangelogModal />);
  }, [gameStarted]);

  const [server, setServer] = useState(Settings.server);
  const [servers, setServers] = useState<any[]>([]);

    const updateServer = (value: any) => {
    setServer(value);
    Settings.server = value;

    // const gameState = (game?.scene.scenes[0] as Game).gameState;
    // TODO: change server without reloading

      window.location.reload();
  }

  useEffect(() => {
    window.addEventListener('assetsLoadProgress', (e: any) => {
      setLoadingProgress(Math.floor(e.detail * 98));
      if(e.detail === 1) setAssetsLoaded(true);
    });
  }, []);


  useEffect(() => {
    if (gameStarted) {
      // prevent accidental exit
      window.onbeforeunload = function(e)
        {
          e.preventDefault();
          return "Are you sure you want to exit";
        }

    } else {
      window.onbeforeunload = null;
    }
  }, [gameStarted]);
  const onGameReady = () => {
    setIsConnected(true);
  };

  useEffect(() => {
    // Check if CrazyGames SDK is being used - if so, wait for auth to complete
    const isCrazygames = crazygamesSDK.shouldUseSDK() && crazygamesSDK.isUserAccountAvailable();

    console.log('Checking if everything is ready. Connected:', isConnected, 'Assets:', assetsLoaded, 'CrazyGames Auth Ready:', crazygamesAuthReady || !isCrazygames);
    if(debugMode) {
      alert('check. Connected: ' + isConnected + ' Assets: ' + assetsLoaded + ' CG Auth: ' + (crazygamesAuthReady || !isCrazygames));
    }

    // Only set to 100% when all conditions are met
    if(isConnected && assetsLoaded && (crazygamesAuthReady || !isCrazygames)) {
      setLoadingProgress(100);
    }
  }, [isConnected, assetsLoaded, crazygamesAuthReady]);

  useEffect(() => {
    console.log('Getting server list');
    getServerList().then(setServers);

    // Check for CrazyGames instant multiplayer or invite params
    let isInstantMultiplayerMode = false;
    try {
      const roomId = crazygamesSDK.getInviteParam('roomId');
      const region = crazygamesSDK.getInviteParam('region');

      if (roomId) {
        console.log('[CrazyGames] Joining via invite link - Room ID:', roomId);
        // Store roomId globally so it can be used when starting the game
        (window as any).inviteRoomId = roomId;
        if (region) {
          console.log('[CrazyGames] Setting region from invite:', region);
          (window as any).inviteRegion = region;
        }
        isInstantMultiplayerMode = true;
      }

      // Check for instant multiplayer mode
      if (crazygamesSDK.isInstantMultiplayer()) {
        console.log('[CrazyGames] Instant multiplayer mode enabled');
        isInstantMultiplayerMode = true;
      }

      // Set instant start flag for loading screen
      if (isInstantMultiplayerMode) {
        (window as any).instantStart = true;
        console.log('[CrazyGames] Instant multiplayer detected - setting instantStart flag');
      }
    } catch (error) {
      console.error('[CrazyGames] Error checking multiplayer settings:', error);
    }

    // Helper function to handle the loginWithSecret callback and return a promise
    const verifyStoredAccount = (existingSecret: string, currentUserId: string): Promise<'match' | 'mismatch' | 'invalid'> => {
      return new Promise((resolve) => {
        console.log('[CrazyGames] verifyStoredAccount called for currentUserId:', currentUserId);
        console.log('[CrazyGames] Sending loginWithSecret request to verify account...');

        api.post(`${api.endpoint}/auth/loginWithSecret`,
          { secret: existingSecret },
          (secretLoginData: any) => {
            console.log('[CrazyGames] verifyStoredAccount callback received:', secretLoginData);

            if (secretLoginData.error || !secretLoginData.account) {
              console.error('[CrazyGames] Error retrieving stored account via secret:', secretLoginData.error);
              resolve('invalid');
              return;
            }

            const storedAccount = secretLoginData.account;
            const storedCrazygamesUserId = storedAccount.crazygamesUserId;

            console.log('[CrazyGames] Stored account crazygamesUserId:', storedCrazygamesUserId);
            console.log('[CrazyGames] Current crazygamesUserId:', currentUserId);

            // Check if stored account belongs to same CrazyGames user
            if (storedCrazygamesUserId === currentUserId) {
              console.log('[CrazyGames] CrazyGames user matches stored account - keeping login');
              // Update account in Redux to ensure it's current
              storedAccount.secret = existingSecret;
              dispatch(setAccount(storedAccount));
              resolve('match');
            } else {
              console.log('[CrazyGames] CrazyGames user mismatch! Stored:', storedCrazygamesUserId, 'Current:', currentUserId);
              resolve('mismatch');
            }
          }
        );
      });
    };

    // Automatic CrazyGames login with user verification
    const attemptCrazygamesLogin = async () => {
      try {
        console.log('[CrazyGames] attemptCrazygamesLogin called');
        console.log('[CrazyGames] shouldUseSDK:', crazygamesSDK.shouldUseSDK());
        console.log('[CrazyGames] isUserAccountAvailable:', crazygamesSDK.isUserAccountAvailable());

        // Only attempt login if on CrazyGames and user accounts are available
        if (!crazygamesSDK.shouldUseSDK() || !crazygamesSDK.isUserAccountAvailable()) {
          console.log('[CrazyGames] SDK not available or user accounts not supported - returning');
          setCrazygamesAuthReady(true);
          return;
        }

        console.log('[CrazyGames] Starting authentication flow...');

        // Get current CrazyGames user
        console.log('[CrazyGames] Calling crazygamesSDK.getUser()...');
        const currentUser = await crazygamesSDK.getUser();
        console.log('[CrazyGames] Current CrazyGames user (raw):', currentUser);
        console.log('[CrazyGames] Current CrazyGames user (JSON):', JSON.stringify(currentUser));
        console.log('[CrazyGames] Current CrazyGames user keys:', currentUser ? Object.keys(currentUser) : 'null');

        let currentUserId: string | undefined = undefined;

        if (currentUser) {
          try {
            console.log('[CrazyGames] User object exists, requesting token to get userId...');
            const token = await crazygamesSDK.getUserToken();

            if (token) {
              const tokenParts = token.split('.');
              if (tokenParts.length === 3) {
                const payload = JSON.parse(atob(tokenParts[1]));
                currentUserId = payload.userId;
                console.log('[CrazyGames] Decoded userId from token:', currentUserId);
              } else {
                console.error('[CrazyGames] Invalid token format - expected 3 parts, got', tokenParts.length);
              }
            } else {
              console.error('[CrazyGames] Failed to get user token');
            }
          } catch (error) {
            console.error('[CrazyGames] Error getting userId from token:', error);
          }
        }

        console.log('[CrazyGames] Final user ID:', currentUserId);

        // Get the stored secret
        const existingSecret = window.localStorage.getItem('secret');
        const hasValidSecret = existingSecret && existingSecret !== 'undefined' && existingSecret !== 'null';

        // Case 1: No CrazyGames user logged in
        if (!currentUserId) {
          console.log('[CrazyGames] No CrazyGames user logged in');

          // If we have a secret, clear it since user is not logged in on CrazyGames
          if (hasValidSecret) {
            console.log('[CrazyGames] Clearing secret as user is not logged in on CrazyGames');
            try {
              window.localStorage.removeItem('secret');
              dispatch(clearAccount());
            } catch (e) {
              console.error('[CrazyGames] Error clearing secret:', e);
            }
          }

          setCrazygamesAuthReady(true);
          return;
        }

        // Case 2: User is logged in on CrazyGames
        console.log('[CrazyGames] User is logged in on CrazyGames - verifying stored account');

        // If we have a secret, verify it matches the current user
        if (hasValidSecret) {
          console.log('[CrazyGames] Have stored secret - verifying against current CrazyGames user');

          // Verify the stored account
          const verifyResult = await verifyStoredAccount(existingSecret, currentUserId);

          if (verifyResult === 'match') {
            // Account matches, we're done
            setCrazygamesAuthReady(true);
            return;
          }

          if (verifyResult === 'invalid') {
            // Secret is invalid, clear it and log in with current user
            try {
              window.localStorage.removeItem('secret');
              dispatch(clearAccount());
            } catch (e) {
              console.error('[CrazyGames] Error clearing invalid secret:', e);
            }
          }

          // For both 'mismatch' and 'invalid', log in with current user
          if (verifyResult === 'mismatch') {
            console.log('[CrazyGames] Switching to current CrazyGames user account');
            // Clear the old secret
            try {
              window.localStorage.removeItem('secret');
              dispatch(clearAccount());
            } catch (e) {
              console.error('[CrazyGames] Error clearing old secret:', e);
            }
          }

          // Login with the current user
          await loginWithCurrentCrazygamesUser(currentUser);
          setCrazygamesAuthReady(true);
        } else {
          // No stored secret but user is logged in on CrazyGames - login with current user
          console.log('[CrazyGames] No stored secret but user is logged in - logging in with current user');
          await loginWithCurrentCrazygamesUser(currentUser);
          setCrazygamesAuthReady(true);
        }
      } catch (error) {
        console.error('[CrazyGames] Auto-login error:', error);
        setCrazygamesAuthReady(true);
      }
    };

    // Helper function to login with current CrazyGames user
    const loginWithCurrentCrazygamesUser = async (currentUser: any) => {
      try {
        console.log('[CrazyGames] loginWithCurrentCrazygamesUser called for user:', currentUser?.username);

        console.log('[CrazyGames] Requesting user token from SDK...');
        const token = await crazygamesSDK.getUserToken();
        console.log('[CrazyGames] Token received:', token ? 'Yes (length: ' + token.length + ')' : 'null/undefined');

        if (!token) {
          console.error('[CrazyGames] Failed to get user token - token is null/undefined');
          return;
        }

        // Decode JWT to get userId
        let userId: string;
        try {
          const tokenParts = token.split('.');
          console.log('[CrazyGames] Token parts count:', tokenParts.length);

          if (tokenParts.length !== 3) {
            console.error('[CrazyGames] Invalid token format - expected 3 parts, got', tokenParts.length);
            return;
          }

          const payload = JSON.parse(atob(tokenParts[1]));
          userId = payload.userId;
          console.log('[CrazyGames] Decoded userId from token:', userId);
        } catch (error) {
          console.error('[CrazyGames] Failed to decode token:', error);
          return;
        }

        console.log('[CrazyGames] Sending login request to', `${api.endpoint}/auth/crazygames/login`);
        console.log('[CrazyGames] Login request payload:', { userId, username: currentUser.username });

        // Return a promise that resolves when the login is complete
        return new Promise<void>((resolve) => {
          api.post(`${api.endpoint}/auth/crazygames/login`, {
            token,
            userId,
            username: currentUser.username,
          }, (data: any) => {
            console.log('[CrazyGames] Login API callback received with data:', data);

            if (data.error) {
              console.error('[CrazyGames] Login failed with error:', data.error);
              resolve();
              return;
            }

            if (data.message) {
              console.error('[CrazyGames] Login failed with message:', data.message);
              resolve();
              return;
            }

            if (data.account && data.secret) {
              console.log('[CrazyGames] Login successful for user:', data.account.username);
              data.account.secret = data.secret;
              dispatch(setAccount(data.account));

              initializeDataStorage().then(() => {
                console.log('[CrazyGames] Data storage initialized after login');
                resolve();
              }).catch(error => {
                console.error('[CrazyGames] Error initializing data storage:', error);
                resolve();
              });
            } else {
              console.error('[CrazyGames] Missing account or secret in response');
              console.log('[CrazyGames] Response had account?', !!data.account, 'secret?', !!data.secret);
              resolve();
            }
          });
        });
      } catch (error) {
        console.error('[CrazyGames] Error logging in with current user:', error);
      }
    };

    // Wait for CrazyGames SDK to be initialized before attempting login
    console.log('[CrazyGames] Initial setup - shouldUseSDK:', crazygamesSDK.shouldUseSDK());

    if (crazygamesSDK.shouldUseSDK()) {
      // SDK should be initializing, wait for it
      const checkSDKReady = async () => {
        console.log('[CrazyGames] checkSDKReady: Starting SDK initialization check');
        let attempts = 0;
        const maxAttempts = 100; // 10 seconds (100 * 100ms)

        while (!crazygamesSDK.isInitialized() && attempts < maxAttempts) {
          if (attempts % 10 === 0) {
            console.log('[CrazyGames] checkSDKReady: Waiting for SDK... attempt', attempts, 'isInitialized:', crazygamesSDK.isInitialized());
          }
          await new Promise(resolve => setTimeout(resolve, 100));
          attempts++;
        }

        console.log('[CrazyGames] checkSDKReady: Final check - isInitialized:', crazygamesSDK.isInitialized(), 'attempts:', attempts);

        if (!crazygamesSDK.isInitialized()) {
          console.warn('[CrazyGames] SDK initialization timeout after', attempts * 100, 'ms');
          setCrazygamesAuthReady(true);
          return;
        }

        console.log('[CrazyGames] SDK initialized after', attempts * 100, 'ms - calling attemptCrazygamesLogin');
        await attemptCrazygamesLogin();
      };

      checkSDKReady().catch(err => {
        console.error('[CrazyGames] checkSDKReady error:', err);
        setCrazygamesAuthReady(true);
      });
    } else {
      // Not on CrazyGames, just call attemptCrazygamesLogin normally
      console.log('[CrazyGames] Not on CrazyGames, calling attemptCrazygamesLogin with delay');
      setTimeout(() => {
        attemptCrazygamesLogin();
      }, 500);
    }

    // Monitor CrazyGames user account changes (login/logout)
    if (crazygamesSDK.shouldUseSDK() && crazygamesSDK.isUserAccountAvailable()) {
      let previousUserId: string | null = null;
      let isInitialized = false;
      let isProcessingChange = false;

      const checkUserAccountChange = async () => {
        try {
          const user = await crazygamesSDK.getUser().catch(() => null);
          const currentUserId = user?.userId || null;
          const existingSecret = window.localStorage.getItem('secret');
          const hasValidSecret = existingSecret && existingSecret !== 'undefined' && existingSecret !== 'null';

          console.log('[CrazyGames Monitor] Check:', {
            currentUserId,
            previousUserId,
            hasSecret: hasValidSecret,
            isInitialized,
            isProcessing: isProcessingChange
          });

          // First time - just initialize
          if (!isInitialized) {
            previousUserId = currentUserId;
            isInitialized = true;
            console.log('[CrazyGames Monitor] Initialized with userId:', currentUserId);
            return;
          }

          // Prevent multiple simultaneous change processing
          if (isProcessingChange) {
            console.log('[CrazyGames Monitor] Already processing a change, skipping');
            return;
          }

          // User logged out (was logged in, now logged out)
          if (previousUserId && !currentUserId) {
            console.log('[CrazyGames Monitor] User logged out - clearing account');

            // Clear stored secret
            if (hasValidSecret) {
              try {
                window.localStorage.removeItem('secret');
                console.log('[CrazyGames Monitor] Secret cleared from localStorage');
              } catch (e) {
                console.error('[CrazyGames Monitor] Error clearing secret:', e);
              }
            }

            // Clear account from Redux store
            dispatch(clearAccount());

            previousUserId = null;
          }
          // User logged in (was logged out, now logged in)
          else if (!previousUserId && currentUserId) {
            console.log('[CrazyGames Monitor] User logged in - reloading page to apply authentication');

            window.onbeforeunload = null;

            window.location.reload();

            previousUserId = currentUserId;
          }
          // User changed account (different userId)
          else if (previousUserId && currentUserId && previousUserId !== currentUserId) {
            console.log('[CrazyGames Monitor] User account changed - reloading page to switch accounts');

            // Clear old secret
            if (hasValidSecret) {
              try {
                window.localStorage.removeItem('secret');
              } catch (e) {
                console.error('[CrazyGames Monitor] Error clearing secret:', e);
              }
            }

            window.onbeforeunload = null;

            window.location.reload();

            previousUserId = currentUserId;
          }
          // Secret exists but no user - clear it
          else if (!currentUserId && hasValidSecret) {
            console.log('[CrazyGames Monitor] No user but secret exists - clearing secret');
            try {
              window.localStorage.removeItem('secret');
              dispatch(clearAccount());
            } catch (e) {
              console.error('[CrazyGames Monitor] Error clearing secret:', e);
            }
          }

          previousUserId = currentUserId;
        } catch (error) {
          console.error('[CrazyGames Monitor] Error checking user account change:', error);
        }
      };

      // Check every 2 seconds
      const intervalId = setInterval(checkUserAccountChange, 2000);

      // Initial check after a short delay to let SDK fully initialize
      setTimeout(checkUserAccountChange, 100);

      return () => clearInterval(intervalId);
    }
  }, [dispatch]);


  useEffect(() => {
    console.log('[DEBUG] Account state changed:', {
      hasAccount: !!account,
      username: account?.username,
      hasSecret: !!account?.secret,
      secretValue: account?.secret,
      isCrazygames: account?.isCrazygames,
      crazygamesUserId: account?.crazygamesUserId,
      isLoggedIn: account?.isLoggedIn
    });
  }, [account]);

  const onStart = () => {
    console.log('Starting game');
    if(!isConnected) {
      alert('Not connected yet');
      return;
    }
    else  {
      const go = () => {
        setGameStarted(true);
        window.phaser_game?.events.emit('startGame', name);
      }
      // playVideoAd().then(() => {
      //   go();
      // }).catch((e) => {
      //   console.log('Error playing video ad', e);
      //   go();
      // });
      go();
    }
  };


  const openSettings = () => setModal(<SettingsModal />);
  const closeModal = () => setModal(null);
  const onHome = () => setGameStarted(false);
  const onConnectionClosed = (reason: string) => {
    console.log('Connection closed', reason);
    setConnectionError(reason);
  }

  const onSucessAuth = () => setModal(null);
  const onLogin = () => setModal(<LoginModal onSuccess={onSucessAuth} />);
  const onSignup = () => setModal(<SignupModal onSuccess={onSucessAuth} />);
  const onLogout = () => dispatch(logoutAsync() as any);
  const onChangeName = () => {
    const newName = prompt('What do you want to change your name to? Please note that you can only change your name once every 7 days.');
    if (!newName) return;

    dispatch(changeNameAsync(newName) as any);
  }
  const onChangeClan = () => {
    const newClan = prompt('What do you want your clan tag to be? Clans can only be 1-5 characters long, and you can only change your clan once every 7 days.');
    if (!newClan) return;

    dispatch(changeClanAsync(newClan) as any);
  }
  const onChangeBio = () => {
    const newBio = prompt('What do you want your bio to be? You can change it whenever you want, but it can only be up to 100 characters long.');
    if (!newBio) return;

    dispatch(changeBioAsync(newBio) as any);
  }
  const onRemoveClan = () => {
    const newClan = prompt('Are you sure you want to remove your clan tag? You cannot change it again for 7 days. Type anything to confirm.');
    if (!newClan) return;

    dispatch(changeClanAsync('X79Q') as any);
  }
  const openShop = () => {
    setModal(<ShopModal account={account} />);
  }

  
  const openInventory = () => {
    setModal(<InventoryModal account={account} />);
  }

  const openLeaderboard = () => {
    window.location.hash = "#/leaderboard";
  };

  useEffect(() => {
    if (modal?.type?.displayName === 'ShopModal') {
      setModal(<ShopModal account={account} />);
    }
    if(account.is_v1) {
      setModal(<MigrationModal account={account} />);
    }
  }, [account]);

  useEffect(() => {
    // Check if we should auto-start the game
    // For CrazyGames, we need to wait for crazygamesAuthReady
    // For non-CrazyGames, we need to wait for accountReady
    const isCrazygames = crazygamesSDK.shouldUseSDK() && crazygamesSDK.isUserAccountAvailable();
    const isAuthReady = isCrazygames ? crazygamesAuthReady : accountReady;

    if(loadingProgress === 100 && isAuthReady && isConnected && (window as any).instantStart) {
      console.log('[CrazyGames] Instant multiplayer - Auto-starting game');
      console.log('[CrazyGames] Conditions met - loadingProgress:', loadingProgress, 'isAuthReady:', isAuthReady, 'isConnected:', isConnected);
      (window as any).instantStart = false;

      setTimeout(() => {
        console.log('[CrazyGames] Triggering auto-start now');
        onStart();
      }, 100);
    }
  }, [loadingProgress, accountReady, crazygamesAuthReady, isConnected]);
  const isLoaded = loadingProgress === 100;
  return (
    <div className="App">
      <LoadingScreen progress={loadingProgress} />
      <GameComponent
        onHome={onHome}
        onGameReady={onGameReady}
        onConnectionClosed={onConnectionClosed}
        dimensions={dimensions}
        loggedIn={account.isLoggedIn}
        game={game}
        setGame={setGame}
      />
      {connectionError && (
        <Modal
          child={<ConnectionError reason={connectionError}/>}
          className="connectionErrorModal"
        />
      )}

      {!gameStarted && (
        <>
        <div className={`${isConnected ? 'loaded mainMenu' : 'mainMenu'}`}>
        <ShopButton account={account} scale={scale.factor} openShop={openShop} />
        {account?.isLoggedIn && (
          <InventoryButton account={account} scale={scale.factor} openInventory={openInventory} />
          )}
        <LeaderboardButton scale={scale.factor} openLeaderboard={openLeaderboard} />
            <div id="contentt" style={scale.styles}>

          <div id="menuContainer" >

            {/* <!-- GAME NAME --> */}
            <div id="gameName"><img src={titleImg} alt="Swordbattle.io" width={750} height={250} className="title-img" />
</div>

            {/* <!-- LOADING TEXT --> */}
            {/* <!-- MENU CARDS --> */}
            <div id="menuCardHolder" className={isSmallIframe ? 'small-iframe' : ''} style={{ display: 'inline-block', height: 'auto !important', position: 'fixed',
    top: '-50%',
    left: '50%',
    transform: 'translate(-50%, -25%)' }} >
              <div className="menu">
                <div className="accountCard menuCard panel">
                  <AccountCard account={account} onLogin={onLogin} onSignup={onSignup} />
                </div>

                {/* <div className="announcementCard menuCard panel">
                    {account?.username === "Update Testing Account" ? (
                      <>
                      <div style={{ fontSize: '15px' }}>
                        UTA info
                      </div>
                      <div style={{ fontSize: '15px' }}>
                        {account?.clan
                        ? `Clan "${account.clan}" has ${clanMemberCount ?? '...'} members, and ${clanXP ?? '...'} total xp`
                        : 'No clan'}
                      </div>
                      </>
                    ) : (
                      <div style={{ fontSize: '15px', color: 'yellow' }}>
                        October 4th: Fighter now loses speed and damage out-of-combat, and balanced most evolutions!
                      </div>
                    )}
                  </div> */}

                {/* <!-- Play --> */}
                <div className="joinCard menuCard panel" style={{ position: 'relative' }}>
                  <div className="joinCardInput">
                    <input
                      type="text"
                      id="nameInput"
                      placeholder="Enter Name"
                      maxLength={20}
                      value={account.isLoggedIn ? account.username : name}
                      onChange={(e) => setName(e.target.value)}
                      style={{ cursor: account.isLoggedIn ? 'not-allowed' : 'text'}}
                      disabled={account.isLoggedIn}
                      autoComplete="none"
                    />
                    <select id="serverBrowser"
                    value={servers.length === 0 ? 'loading' : server}
                    onChange={(e) => updateServer(e.target.value)}
                    >
                    {servers.length === 0 && <option value="loading" disabled>Loading...</option>}
        {servers.map((server) => <option key={server.value} value={server.value} disabled={server.offline}>
          {server.name} ({server.offline ? 'OFFLINE' : `${server.playerCnt} players - ${server.ping}ms`})
        </option>)}
                    </select>

                    <div id="enterGame" className="menuButton" onClick={() => {
                        if (accountReady && isConnected) {
                          if (account.isLoggedIn && account.username.startsWith(".")) {alert(
                            "Your account has been temporarily suspended due to violations of the game's rules. This restriction will be lifted soon. Please log out to play with a different account."
                            ); return; } onStart(); }}}>
                        {(accountReady && isConnected) ? 'Play!' : 'Connecting...'}
                    </div>
                  </div>
                </div>
                <div className="accountCard menuCard panel">
                  <ChangelogCard/>
                </div>
              </div>
              <div
                className="panel tipCard"
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  width: '75%',
                  margin: 'auto',
                  marginTop: 5,
                  padding: 7,
                  fontSize: 12, // change back to 13
                  boxSizing: 'border-box',
                  maxWidth: '100%',
                  color: 'white'
                }}
                title={randomMessage}
              >
                {randomMessage}
                {/* Due to a bug duplicating Snowtokens earned multiple times, some winter skins may have been refunded. Sorry for the inconvenience. */}
              </div>
              <br />
              <div className='fullWidth'>
                <div id="adBelow">
                 <Ad screenW={dimensions.width} screenH={dimensions.height} types={[[728, 90], [970, 90], [970, 90]]} />
                </div>
              </div>
            </div>

</div>
          </div>

          {/* <!-- BUTTONS --> */}
          <div style={bottomLeftContainerStyle} className="bottom-left-buttons">
          <div id="settingsButton" className="altLink panel" style={{ pointerEvents: 'auto' }} onClick={openSettings}>
            <FontAwesomeIcon icon={faGear} className='ui-icon'/>
          </div>

          <a id="githubButton" className="altLink imgPanel" href="https://github.com/codergautam/swordbattle.io" target="_blank" rel="nofollow" style={{ pointerEvents: 'auto' }}>
            <img src={GithubLogo} width={60} alt="GitHub" />
          </a>
          <a id="discordButton" className="altLink imgPanel" href="https://discord.com/invite/9A9dNTGWb9" target="_blank" rel="nofollow" style={{ pointerEvents: 'auto' }}>
            <img src={DiscordLogo} width={60} alt="Discord" />
          </a>
          {!crazygamesSDK.shouldUseSDK() && (
            <div id="playlightButton" className="imgPanel" style={{ pointerEvents: 'auto' }} onClick={() => {
                try {
                  (window as any)?.showPlaylight();
                } catch (e) {
                  console.log('Error showing playlight', e);
                }
              }}>
              More Games
            </div>
          )}
          </div>
          {modal && <Modal child={modal} close={closeModal} scaleDisabled={modal.type.name === 'ShopModal'} />}

<div className="auth-buttons" style={scale.styles}>
             {account.isLoggedIn ? (
               <div className="dropdown">
                {account.clan ? (
                    <div className="auth-username">
                    <FontAwesomeIcon icon={faUser} />{' '}
                    {account.clan?.toUpperCase() !== 'X79Q' && (
                      <span style={{ color: 'yellow' }}>[{account.clan?.toUpperCase()}]</span>
                    )}{' '}
                    {account.username}
                    </div>
                ) : (
                  <div className="auth-username">
                    <FontAwesomeIcon icon={faUser} /> {account.username}
                  </div>
                )}
                 <ul className="dropdown-menu">
                   <li>
                   <a className="dropdown-item" href="#" onClick={onChangeName}>
                     <FontAwesomeIcon icon={faICursor} /> Change Name
                   </a>
                    </li>
                    {!crazygamesSDK.getSettings().disableChat && !Settings.disableChat && (
                      <li>
                        <a className="dropdown-item" href="#" onClick={onChangeBio}>
                          <FontAwesomeIcon icon={faICursor} /> Change Bio
                        </a>
                      </li>
                    )}
                    <li>
                   <a className="dropdown-item" href="#" onClick={onChangeClan}>
                     <FontAwesomeIcon icon={faICursor} /> Change Clan
                   </a>
                   </li>
                   <li>
                   <a className="dropdown-item" href="#" onClick={onRemoveClan}>
                     <FontAwesomeIcon icon={faX} /> Remove Clan
                   </a>
                   </li>
                   {!account.isCrazygames && (
                     <li><a className="dropdown-item" href="#" onClick={onLogout}>
                       <FontAwesomeIcon icon={faSignOut} /> Logout
                     </a></li>
                   )}
                 </ul>
               </div>
             ) : (
               <>
               {!crazygamesSDK.shouldUseSDK() && (
                 <>
                   <img src={LoginImg} alt="Login" role="button" className="auth-btn" onClick={onLogin} />
                   <img src={SignupImg} alt="Signup" role="button" className="auth-btn" onClick={onSignup} />
                 </>
               )}
               </>
             )}
           </div>


          {/* <!-- LINKS CONTAINERS --> */}
          {/* <div id="linksContainer" className='panel'>
            <a href="./docs/terms.txt" target="_blank">Policy</a> |
            <a href="./docs/privacy.txt" target="_blank">Privacy</a>
          </div> */}
                 <footer className={clsx('links', isLoaded && 'animation')} style={scale.styles}>
             {/* Footer not in use for now */}
           </footer>
        </div>

        </>
      )}
    </div>
  );
}

export default App;
